







































import { Component, Prop, Watch, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  AlertMessage,
  bibliographyContentApi,
  BibliographyContentDetail,
  BibliographyRealDetailContent as RealDetailContent,
  defaultBibliographyContentDetail,
  defaultBibliographyRealDetailContent,
  ErrorMessage,
  FirstMarcLabel,
  marcLabelApi,
  SystemCode
} from '@/api'
import { AlertCodeALC00007, BibliographyClass } from '@/types'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { AlertFactory } from '@/factory'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'

import { BibliographyTagDataList } from '@/components/templates/bibliography-tag-data-list'
import CollectionContentTreeItemAction from '@/components/templates/collection-content/CollectionContentTreeItemAction.vue'
import CollectionContentTreeItemInfoTable from '@/components/organisms/CollectionContentTreeItemInfoTable/CollectionContentTreeItemInfoTable.vue'
import ModalContentSort from '@/components/modals/ModalContentSort/ModalContentSort.vue'
import { Emit } from '@/node_modules/nuxt-property-decorator'

@Component({
  components: {
    ModalContentSort,
    CollectionContentTreeItemInfoTable,
    BibliographyTagDataList,
    CollectionContentTreeItemAction
  }
})
export default class BibliographyRealDetailContent extends ComponentVue {
  @Ref()
  modalContentSort!: ModalContentSort

  @Prop({
    type: Object,
    required: true
  })
  searchType!: SystemCode

  @Prop({
    type: Array,
    required: true
  })
  contents!: RealDetailContent[]

  @Prop({
    type: Number,
    required: true
  })
  bibliographyRealId!: number

  @Prop({
    type: Number,
    required: true
  })
  tableBodyHeight!: number

  selectedContent: RealDetailContent = defaultBibliographyRealDetailContent()

  selectedContentDetail: BibliographyContentDetail = defaultBibliographyContentDetail()

  firstMarcLabels: FirstMarcLabel[] = []

  get existsContents(): boolean {
    return this.contents.length > 0
  }

  mounted() {
    this.fetchMarcLabel().then(this.onFetchedMarcLabel)
  }

  @Watch('contents', { immediate: true, deep: true })
  onChangeRealDetail() {
    if (this.contents.length > 0) {
      this.onSelectedContent(0)
    } else {
      this.selectedContent = defaultBibliographyRealDetailContent()
      this.selectedContentDetail = defaultBibliographyContentDetail()
    }
  }

  openModalContentSort(): void {
    this.modalContentSort.open({
      bibliographyRealId: this.bibliographyRealId,
      tableItems: this.contents,
      onClickRegisterCallback: () => {
        this.$emit('updated:content')
      }
    })
  }

  onSelectedContent(index: number) {
    const content = this.contents[index]
    if (content.bibliographyId === this.selectedContent.bibliographyId) {
      return
    }
    this.selectedContent = content
    this.fetchContentDetail()
  }

  onClickRemove() {
    const alert = AlertFactory.create(AlertCodeALC00007, '内容', '削除')
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.removeContent()
      }
    })
  }

  onClickAdd() {
    this.$modalBibliographyTagDataEdit.open({
      bibliographyClass: BibliographyClass.Content,
      searchType: this.searchType,
      bibliographyRealId: this.bibliographyRealId,
      serial: this.selectedContent.serial + 1,
      onOk: () => {
        this.$emit('updated:content')
      }
    })
  }

  onClickEdit() {
    this.$modalBibliographyTagDataEdit.open({
      isEdit: true,
      bibliographyClass: BibliographyClass.Content,
      searchType: this.searchType,
      editBibliographyId: this.selectedContentDetail.bibliography
        .bibliographyId,
      details: this.selectedContentDetail.details,
      authorities: this.selectedContentDetail.authorities,
      revision: this.selectedContentDetail.bibliography.revision,
      onOk: () => {
        this.fetchContentDetail()
        this.$emit('updated:content')
      }
    })
  }

  onClickCopy() {
    const alert = AlertFactory.create(AlertCodeALC00007, '内容', '複写')
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        const nextSerial = this.contents[this.contents.length - 1].serial + 1
        this.$modalBibliographyTagDataEdit.open({
          isCopy: true,
          bibliographyClass: BibliographyClass.Content,
          searchType: this.searchType,
          bibliographyRealId: this.bibliographyRealId,
          serial: nextSerial,
          details: this.selectedContentDetail.details,
          authorities: this.selectedContentDetail.authorities,
          onOk: () => {
            this.$emit('updated:content')
          }
        })
      }
    })
  }

  async fetchMarcLabel(): Promise<void> {
    try {
      this.firstMarcLabels = await marcLabelApi.getAll(
        BibliographyClass.Content,
        this.searchType,
        false
      )
    } catch (error) {
      if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async fetchContentDetail(): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.selectedContentDetail = await bibliographyContentApi.getById(
        this.selectedContent.bibliographyId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  async removeContent() {
    this.$eventBus.emit(PAGE_LOADING_START)
    try {
      await bibliographyContentApi.delete(
        this.selectedContent.bibliographyId,
        this.selectedContent.revision
      )
      this.$emit('updated:content')
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  @Emit('fetched')
  onFetchedMarcLabel(): void {}
}
